import { render, staticRenderFns } from "./TestimoniosComponent.vue?vue&type=template&id=323d2452&scoped=true"
import script from "./TestimoniosComponent.vue?vue&type=script&lang=js"
export * from "./TestimoniosComponent.vue?vue&type=script&lang=js"
import style0 from "./TestimoniosComponent.vue?vue&type=style&index=0&id=323d2452&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323d2452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323d2452')) {
      api.createRecord('323d2452', component.options)
    } else {
      api.reload('323d2452', component.options)
    }
    module.hot.accept("./TestimoniosComponent.vue?vue&type=template&id=323d2452&scoped=true", function () {
      api.rerender('323d2452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/landingPage/TestimoniosComponent.vue"
export default component.exports